import { ReactComponent as Fire } from '../../assets/icons/Fire.svg';
import { ReactComponent as Light } from '../../assets/icons/Light.svg';
import { ReactComponent as Drop } from '../../assets/icons/Drop.svg';
import { ReactComponent as Signal } from '../../assets/icons/Signal.svg';
import { ReactComponent as Storefront } from '../../assets/icons/Storefront.svg';
import { ReactComponent as Services } from '../../assets/icons/Services.svg';
import { ReactComponent as Phone } from '../../assets/icons/Phone.svg';
import { ReactComponent as Mobile } from '../../assets/icons/Mobile.svg';
import { ReactComponent as License } from '../../assets/icons/License.svg';
import { ReactComponent as UsersThree } from '../../assets/icons/UsersThree.svg';
import { ReactComponent as Cooperatives } from '../../assets/icons/Cooperatives.svg';
import { ReactComponent as TwoSheets } from '../../assets/icons/TwoSheets.svg';
import { ReactComponent as Heart } from '../../assets/icons/Heart.svg';
import { ReactComponent as House } from '../../assets/icons/House.svg';
import { ReactComponent as Bank } from '../../assets/icons/Bank.svg';
import { ReactComponent as Church } from '../../assets/icons/Church.svg';
import { ReactComponent as Books } from '../../assets/icons/Books.svg';
import { ReactComponent as Keyhole } from '../../assets/icons/Keyhole.svg';
import { ReactComponent as Clover } from '../../assets/icons/Clover.svg';
import { ReactComponent as Newspaper } from '../../assets/icons/Newspaper.svg';
import { ReactComponent as Wash } from '../../assets/icons/Wash.svg';
import { ReactComponent as ShieldCheck } from '../../assets/icons/ShieldCheck.svg';
import { ReactComponent as Calculator } from '../../assets/icons/Calculator.svg';
import { ReactComponent as Bible } from '../../assets/icons/Bible.svg';
import { ReactComponent as ServicesPublic } from '../../assets/icons/ServicesPublic.svg';
import { ReactComponent as ServicesPrivate } from '../../assets/icons/ServicesPrivate.svg';
import { ReactComponent as Airplane } from '../../assets/icons/Airplane.svg';
import { ReactComponent as Cross } from '../../assets/icons/Cross.svg';
import { ReactComponent as Transport } from '../../assets/icons/Transport.svg';
import { ReactComponent as Detective } from '../../assets/icons/Detective.svg';
import { ReactComponent as ThreePoints } from '../../assets/icons/ThreePoints.svg';
import { ReactComponent as Notebook } from '../../assets/icons/Notebook.svg';

/* export const AgreementIcons = {
  1: {
    icon: '',
    label: 'Servicios Públicos'
  },
  2: {
    icon: '',
    label: 'Servicios Privados'
  },
  3: {
    icon: <Bank />,
    label: 'Gobierno y Estado'
  },
  4: {
    icon: <Drop />,
    label: 'Agua'
  },
  5: {
    icon: <Wash />,
    label: 'Aseo'
  },
  6: {
    icon: <Light />,
    label: 'Luz'
  },
  7: {
    icon: <Fire />,
    label: 'Gas'
  },
  8: {
    icon: <Signal />,
    label: 'Telefonía y TV'
  },
  10: {
    icon: <UsersThree />,
    label: 'Cajas De Compensación'
  },
  11: {
    icon: <Books />,
    label: 'Instituciones Educativas y Colegios'
  },
  12: {
    icon: <Storefront />,
    label: 'Comercios y Distribuidoras'
  },
  13: {
    icon: <House />,
    label: 'Conjuntos Residenciales'
  },
  14: {
    icon: <Cooperatives />,
    label: 'Cooperativas'
  },
  15: {
    icon: <Newspaper />,
    label: 'Periódicos y Revistas'
  },
  16: {
    icon: <Heart />,
    label: 'Fondos y  Fundaciones'
  },
  17: {
    icon: <Bible />,
    label: 'Funerarias'
  },
  18: {
    icon: <Church />,
    label: 'Iglesias'
  },
  19: {
    icon: <Keyhole />,
    label: 'Inmobiliaria'
  },
  20: {
    icon: <Clover />,
    label: 'Loterías'
  },
  21: {
    icon: <ShieldCheck />,
    label: 'Seguros'
  },
  22: {
    icon: <Fire />,
    label: 'Salud, Medicina Prepagada y Pila'
  },
  23: {
    icon: <Calculator />,
    label: 'Servicios Financieros'
  },
  24: {
    icon: <Phone />,
    label: 'Telefonía Fija'
  },
  25: {
    icon: <Wash />,
    label: 'Servicio De Transporte'
  },
  28: {
    icon: <Bank />,
    label: 'Entidades Gubernamentales'
  },
  29: {
    icon: <License />,
    label: 'Impuestos'
  },
  30: {
    icon: <Services />,
    label: 'Multiservicios'
  },
  31: {
    icon: '',
    label: 'Otros'
  },
  32: {
    icon: '',
    label: 'Apuestas Deportivas'
  },
  33: {
    icon: '',
    label: 'Pila'
  }
}; */

export const AgreementIcons = {
  1: {
    label: 'SERVICIOS PUBLICOS',
    icon: <ServicesPublic />
  },
  2: {
    label: 'SERVICIOS PRIVADOS',
    icon: <ServicesPrivate />
  },
  3: {
    label: 'GOBIERNO/ESTADO',
    icon: <Bank />
  },
  4: {
    label: 'ACUEDUCTO',
    icon: <Drop />
  },
  5: {
    label: 'ASEO',
    icon: <Wash />
  },
  6: {
    label: 'ENERGIA',
    icon: <Light />
  },
  7: {
    label: 'GAS',
    icon: <Fire />
  },
  8: {
    label: 'TELEFONIA FIJA',
    icon: <Phone />
  },
  9: {
    label: 'AEROLINEAS Y AGENCIAS DE VIAJES',
    icon: <Airplane />
  },
  10: {
    label: 'CAJAS DE COMPENSACION',
    icon: <UsersThree />
  },
  11: {
    label: 'INSTITUCIONES EDUCATIVAS/COLEGIOS',
    icon: <Books />
  },
  12: {
    label: 'COMERCIOS/DISTRIBUIDORAS',
    icon: <Storefront />
  },
  13: {
    label: 'CONJUNTOS RESIDENCIALES',
    icon: <House />
  },
  14: {
    label: 'COOPERATIVAS',
    icon: <Cooperatives />
  },
  15: {
    label: 'PERIODICOS/REVISTAS',
    icon: <Newspaper />
  },
  16: {
    label: 'FONDOS/FUNDACIONES',
    icon: <Heart />
  },
  17: {
    label: 'FUNERARIAS',
    icon: <Bible />
  },
  18: {
    label: 'IGLESIAS',
    icon: <Church />
  },
  19: {
    label: 'INMOBILIARIA',
    icon: <Keyhole />
  },
  20: {
    label: 'LOTERIAS',
    icon: <Clover />
  },
  21: {
    label: 'SEGUROS',
    icon: <ShieldCheck />
  },
  22: {
    label: 'SALUD/MEDICINA PREPAGADA/PILA',
    icon: <Cross />
  },
  23: {
    label: 'SERVICIOS FINANCIEROS',
    icon: <Calculator />
  },
  24: {
    label: 'TELEFONIA MOVIL/TV POR SUSCRIPCION',
    icon: ''
  },
  25: {
    label: 'SERVICIO DE TRANSPORTE',
    icon: <Transport />
  },
  26: {
    label: 'VALORES Y VIGILANCIA',
    icon: <Detective />
  },
  27: {
    label: 'CAMARA DE COMERCIO',
    icon: <TwoSheets />
  },
  28: {
    label: 'ENTIDADES GUBERNAMENTALES',
    icon: <Bank />
  },
  29: {
    label: 'IMPUESTOS',
    icon: <License />
  },
  30: {
    label: 'MULTISERVICIOS',
    icon: <Services />
  },
  31: {
    label: 'OTROS',
    icon: <ThreePoints />
  },
  CATALOGS_SELLS: {
    label: 'Ventas por catálogo',
    icon: <Notebook />
  }
};
